import { render, staticRenderFns } from "./ConfirmRenewal.vue?vue&type=template&id=24cd305d&"
import script from "./ConfirmRenewal.vue?vue&type=script&lang=js&"
export * from "./ConfirmRenewal.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmRenewal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports